import { createSelector } from 'reselect';

const currentPath = state => state.routing.location.pathname;
const accessInfo = state => state.SecurityState.accessInfo;

export const getIsReadOnly = createSelector(
  [currentPath, accessInfo],
  (currentPath, accessInfo) => {
    const parts = currentPath.substring(1).split('/') || [];
    const pageSecurity = accessInfo.find(
      x => x.PathUrlSegment === `/${parts[0]}`
    );

    if (pageSecurity) {
      return !pageSecurity.WriteAccess;
    }

    return true;
  }
);



// WEBPACK FOOTER //
// ./src/common/Selectors/ReadOnlySelector.js